import helper from 'store/helper';
import types from './types';

const requestStart = () => helper.createAction(types.REQUEST_START);
const requestFailed = (error) => helper.createAction(types.REQUEST_FAILED, error);
const fetchSucceeded = (data) => helper.createAction(types.FETCH_SUCCEEDED, data);
const fetch = (data) => helper.createAction(types.FETCH, data);
const fetchDefault = (data) => helper.createAction(types.FETCH_DEFAULT, data);
const changeFuncId = (funcId) => helper.createAction(types.CHANGE_FUNC_ID, { funcId });

export default {
  requestStart,
  requestFailed,
  fetchSucceeded,
  fetch,
  fetchDefault,
  changeFuncId,
};
